module.exports = __webpack_public_path__ + "img/folder.5cbcba92.svg";